import { InboxContext } from '../types';
import { ServiceSessionEvent } from '@modules/ServiceModule';
import TasksModule from '@modules/TasksModule';
import { TaskState } from '@modules/TasksModule/types';
import { setCallToAbandoned } from '../callHandlers/callStateHandler';

function handleSessionDeleted(
  context: InboxContext,
  event: ServiceSessionEvent,
) {
  // we should be getting a rescinded event from kazoo
  // when a customer hangs up prior to an agent
  // accepting, but we just get this. For now, treat it
  // like an abandoned event unless it is accepted or
  // timed out. Session deleted event is still emitted
  // for accepted and timed out calls but we don't want
  // to treat them as abandoned.

  const task = TasksModule.getTaskBySessionSid(event.sessionSid) ?? null;

  // we don't want to handle for outbound calls
  // as the user may have started an outbound via a queue
  // and would get this event after the call is completed
  // but the starter of the outbound call doesn't need to
  // handle/be concerned about the session events.
  if (!task || task.isOutbound) {
    return;
  }

  if (task.state === TaskState.Offered) {
    setCallToAbandoned({
      context,
      taskId: task.id,
      eventType: 'session-deleted',
    });
  }
}

export default handleSessionDeleted;
